import { Button, ButtonProps } from '@mui/material'
import { colorPalette } from '../../../style/colorPalette'

type Props = {
  isSelected?: boolean
} & ButtonProps

const ColumnFilterButton = (props: Props) => {
  const { classes, title, isSelected, ...other } = props
  return (
    <Button
      {...other}
      variant="outlined"
      size="small"
      sx={{
        background: isSelected ? colorPalette.skyBlue[7] : 'transparent',
        color: isSelected ? colorPalette.monotone[0] : colorPalette.monotone[5],
        border: `1px solid ${colorPalette.monotone[2]}`,
        margin: '0 2px',
        minWidth: 'fit-content',
        height: '24px',
        borderRadius: '17px',
        '&:hover': {
          background: isSelected ? colorPalette.skyBlue[7] : 'transparent',
          border: `1px solid ${colorPalette.monotone[2]}`,
        },
      }}
    >
      {title}
    </Button>
  )
}

export default ColumnFilterButton
